import { render } from "./WelcomeCompany.vue?vue&type=template&id=12379929"
import script from "./WelcomeCompany.vue?vue&type=script&lang=js"
export * from "./WelcomeCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__